import React from "react";
import RegistrationSlider from "./slider";
import {
  BottomContainer,
  Container,
  Description,
  Heading,
  IMainContainer,
  InnerTopContainer,
} from "./styled.components";

const Enlishments = () => {
  return (
    <Container>
      <IMainContainer>
        <InnerTopContainer>
          <Heading>Registration & Enlishments</Heading>
          <Description>
            HHH and Sons Presents a Proud Past And Will Keep The
            Promise For Days To Come
          </Description>
        </InnerTopContainer>
      </IMainContainer>
      <BottomContainer>
        <RegistrationSlider />
      </BottomContainer>
    </Container>
  );
};

export default Enlishments;
